module.exports = __webpack_public_path__ + "img/labor_day_card_mob_clearance_v1.ef0f8a0.png";